import { rem } from "polished";
import { createGlobalStyle } from "styled-components";

import noScrollBar from "./no-scrollbar";

const GlobalStyles = createGlobalStyle`
/* CSS reset */
html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  margin: 0;
  padding: 0;
  border: 0;
  vertical-align: baseline;
}

/* HTML5 display-role reset for older browsers */
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  display: block;
}
body {
  line-height: 1;
}
ol,
ul {
  list-style: none;
}
blockquote,
q {
  quotes: none;
}
blockquote::before,
blockquote::after,
q::before,
q::after {
  content: "";
  content: none;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}

:root {
  --block-outline-size: 2px;
  --z-index-base: 0;
  --z-index-lowest: 1;
  --z-index-low: 2;
  --z-index-medium: 3;
  --z-index-high: 4;
  --z-index-highest: 5;
  --z-index-ultra: 6;
  --frame-sticky-offset: 0;
}

html,
body {
  font-family: "Inter" !important;
  font-weight: 400;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.disable-page-scroll {
  overflow: hidden;
  
}

.disable-scroll {
  overflow: hidden;
}

.block-sticky {
  position: sticky !important;

  /* Temporary solution when there's a sticky banner (ie: enter-event banner) at the top  */
  top: var(--frame-sticky-offset)!important;
  z-index: var(--z-index-medium);
}

.block-on-top {
  position: absolute !important;
  top: 0;
  z-index: var(--z-index-high);
  width: 100%
}

.app-loader-visible .hide-when-app-loading {
  display: none;
}

[contenteditable] {
  user-select: text;
  outline: none;
}

div[role="tooltip"] {
  z-index: var(--z-index-medium);
}

.Toastify__toast {
  border-radius: 6px;
  min-height: unset;
}

.Toastify__toast-container {
  top: 80px;
  width: unset;
}

.Toastify__toast-body {
  margin: 0;
  color: var(--color-white);
}

.Toastify__toast--default {
  background-color: var(--color-primary);
}

.Toastify__toast--info {
  background-color: var(--color-primary);
}

.Toastify__toast--success {
  background-color: var(--color-green-500);
}

.Toastify__toast--warn {
  background-color: var(--color-yellow-500);
}

.Toastify__toast--error {
  background-color: var(--color-red-500);
}

/* Content Hub: video share URL copied — dark bar, mint text, custom close */
.Toastify__toast--video-share-copied {
  background-color: #344038;
  box-shadow: none;
  min-height: unset;
  padding: 12px 16px;
  border-radius: 8px;
}

.Toastify__toast--video-share-copied .Toastify__toast-body--video-share-copied {
  margin: 0;
  padding: 0;
  width: 100%;
  color: #b6e8c0;
}

// ***********************   CKEditor   *********************** //

:root {
  --ck-spacing-small: ${rem(5)};
  --ck-ui-component-min-height: ${rem(37)};
  --ck-shadow: 0 ${rem(5)} ${rem(15)} rgba(27, 31, 41, 0.25);
  --ck-image-style-spacing: ${rem(32)};
  .loader-dots {
    --dot-color: white;
  }
}

.ck.ck-icon :not([fill]) {
  fill: var(--color-gray-400);
}

.ck.ck-toolbar {
  font-size: ${rem(12)};
  padding: 0 ${rem(5)};
  color: var(--color-gray-400);
  background: var(--color-gray-900);
  box-shadow: var(--ck-shadow);
  border: var(--color-gray-900);
  border-radius: ${rem(4)} !important;
}

// overflow menu
.ck.ck-dropdown__panel.ck-dropdown__panel_sw {
  border-top-right-radius: ${rem(4)};
}

.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_se {
  left: 50%;
  transform: translateX(-60%);
  right: unset;
}

// separator
.ck.ck-toolbar .ck.ck-toolbar__separator {
  background: var(--color-gray-700);
  margin-top: ${rem(8)};
  margin-bottom: ${rem(8)};
}

// buttons
.ck.ck-button {
  color: var(--color-gray-400);
  line-height: ${rem(20)};
  cursor: pointer;
}

.ck.ck-button.ck-on,
.ck.ck-list__item .ck-button.ck-on {
  color: var(--color-gray-400);
  background: #000;
}

.ck.ck-button.ck-on.ck-disabled {
  background: #000;
}

.ck.ck-button.ck-disabled {
  cursor: not-allowed;
}

.ck.ck-button.ck-on svg path {
  fill: #fff;
} 

.ck.ck-button:not(.ck-disabled):hover,
.ck.ck-list__item .ck-button:hover:not(.ck-disabled) {
  background:  #A33AFFBD;
}

.ck.ck-button.ck-on:not(.ck-disabled):hover,
.ck.ck-list__item .ck-button.ck-on:hover:not(.ck-disabled) {
  background: #7E2DE6;
}

.ck.ck-toolbar__items .ck.ck-dropdown .ck-button.ck-dropdown__button:not(.ck-button_with-text) {
  padding: inherit;
}

.ck.ck-icon.ck-dropdown__arrow {
  display: none;
}

// dropdown
.ck.ck-dropdown__panel {
  border: none;
  background: var(--color-gray-900);
}

.ck.ck-dropdown__panel .ck-list {
  border-radius: ${rem(4)} !important;
  background: var(--color-gray-900);
  border: ${rem(1)} solid var(--color-gray-900);
}

// link embed field
.ck.ck-balloon-panel {
  border: none;
  color: var(--color-gray-400);
  background: var(--color-gray-900);
  box-shadow: var(--ck-shadow);
}

.ck.ck-balloon-panel.ck-balloon-panel_with-arrow::after,
.ck.ck-balloon-panel.ck-balloon-panel_with-arrow::before {
  border-color: transparent transparent var(--color-gray-900) transparent; 
}

.ck.ck-link-form {
  padding: ${rem(12)};
  align-items: center;
}

.ck.ck-link-actions .ck-button.ck-link-actions__preview {
  display: flex;
  align-items: center;
}

.ck.ck-link-actions .ck-button.ck-link-actions__preview .ck-button__label {
  font-size: ${rem(12)};
  color: var(--color-blue-300);
  line-height: ${rem(24)};
}

.ck.ck-input-text {
  border: ${rem(1)} solid var(--color-gray-700);
  background: var(--color-gray-900);
  min-height: ${rem(32)};
  font-size: ${rem(12)};
  padding: ${rem(6)} ${rem(8)};
  line-height: ${rem(20)};
  color: #fff;
}

.ck.ck-input-text:focus {
  box-shadow: none;
}

.ck.ck-input-text::placeholder {
  color: var(--color-gray-400);
}

.ck.ck-media-form .ck-labeled-field-view__status {
  font-weight: 500;
  font-size: ${rem(10)};
  line-height: ${rem(12)};
  color: var(--color-gray-400);
}

.ck.ck-content.ck-editor__editable {
  padding: 0;
  border: none;
}

.ck.ck-editor__editable:not(.ck-editor__nested-editable).ck-focused {
  border: none;
}

.ck-content {
  word-break: break-word;
}

.ck-content *:last-child {
  margin-bottom: 0;
}

.ck-content strong {
  font-weight: bolder;
}

.ck-content ul,
.ck-content ol {
  padding-left: ${rem(18)};
  margin-left: 0;
  margin-bottom: ${rem(24)};
}

.ck-content ol {
  list-style: decimal;
}

.ck-content ul {
  list-style: disc;
}

.ck-content h2 {
  font-size: ${rem(64)};
  line-height: ${rem(72)};
}

.ck-content h3 {
  font-size: ${rem(32)};
  line-height: ${rem(40)};
}

.ck-content h4 {
  font-size: ${rem(24)};
  line-height: ${rem(32)};
}

.ck-content h5 {
  font-size: ${rem(20)};
  line-height: ${rem(32)};
}

.ck-content h2,
.ck-content h3,
.ck-content h4 {
  margin-bottom: ${rem(24)};
}

.ck-content a {
  color: var(--color-blue-400);
  text-decoration: none;
}

.ck-content li {
  line-height: ${rem(24)};
  font-size: ${rem(18)};
  margin-bottom: ${rem(8)};
}

.ck-content ul ul,
.ck-content ul ol,
.ck-content ol ul,
.ck-content ol ol {
  padding-left: 0;
  margin-bottom: 0;
}

.ck-color-grid__tile {
  border-radius: 100% !important;
}

// Fullscreen player overlay description (preview / published)
.video-public-description-content .ck-content p,
.video-public-description-content .ck-content li {
  font-family: Inter, sans-serif;
  font-size: ${rem(16)} !important;
  font-weight: 400;
  line-height: ${rem(24)};
  color: #fff;
  overflow-wrap: break-word;
  word-wrap: break-word;
}

.video-public-description-content .ck-content li {
  margin-bottom: ${rem(4)};
}

.video-public-description-content .ck-content ul,
.video-public-description-content .ck-content ol {
  padding-left: 0 !important;
  margin-left: 0;
  list-style-position: inside;
}

// Video / Video Grid Details — light toolbar in preference panel (content hub)
.video-details-description-editor {
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: ${rem(1)} solid rgba(0, 0, 0, 0.2);
  border-radius: ${rem(8)};
  background: #fff;

  /* Focus ring above scrollbar (bottom-right corner was clipped on the shell border). */
  &::after {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: inherit;
    border: ${rem(1)} solid transparent;
    pointer-events: none;
    z-index: 2;
  }

  &:focus-within {
    /* Single 1px ring (matches Title input); shell border hidden to avoid double stroke. */
    border-color: transparent;

    &::after {
      border-color: var(--color-primary);
    }
  }

  > [role="presentation"] {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    width: 100%;

    > div {
      display: flex;
      flex-direction: column;
      flex: 1;
      min-height: 0;
    }
  }

  .ck.ck-editor__editable.ck-editor__editable_inline {
    min-height: ${rem(96)};
    max-height: ${rem(240)};
    overflow-y: auto;
    scrollbar-gutter: stable;
    padding: ${rem(12)} ${rem(16)};
    font-size: ${rem(14)};
    line-height: ${rem(20)};
    border: none;
    border-radius: 0 0 ${rem(7)} ${rem(7)};
  }

  .ck.ck-editor__editable.ck-focused,
  .ck.ck-editor__editable:not(.ck-editor__nested-editable).ck-focused {
    outline: none;
    box-shadow: none;
    border: none;
  }

  .ck-content {
    min-height: ${rem(72)};
  }

  .document-editor__toolbar {
    position: static;
    left: 0;
    margin: 0;
    width: 100%;
    max-width: 100%;
    transform: none;
  }

  .ck.ck-toolbar {
    width: 100%;
    font-size: ${rem(12)};
    padding: 0 ${rem(5)};
    color: var(--color-gray-800);
    background: #fff;
    box-shadow: none;
    border: none;
    border-bottom: ${rem(1)} solid rgba(0, 0, 0, 0.1);
    border-radius: ${rem(7)} ${rem(7)} 0 0 !important;
  }

  .ck.ck-toolbar .ck.ck-toolbar__separator {
    background: rgba(0, 0, 0, 0.15);
  }

  .ck.ck-button {
    color: var(--color-gray-700);
  }

  .ck.ck-button.ck-on,
  .ck.ck-list__item .ck-button.ck-on,
  .ck.ck-button.ck-on.ck-disabled {
    color: var(--color-gray-900);
    background: var(--color-gray-200);
  }

  .ck.ck-button.ck-on svg path {
    fill: var(--color-gray-800);
  }

  .ck.ck-button:not(.ck-disabled):hover,
  .ck.ck-list__item .ck-button:hover:not(.ck-disabled) {
    background: var(--color-gray-100);
  }

  .ck.ck-button.ck-on:not(.ck-disabled):hover,
  .ck.ck-list__item .ck-button.ck-on:hover:not(.ck-disabled) {
    background: var(--color-gray-300);
  }
}

// Reduce width of option for liquid tags inside the toolbar
.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-liquid-tag-dropdown .ck-button__label {
  width: unset;
}

.grabbing * {
  cursor: grabbing !important;
}

.highlight-selector {
  box-shadow: 0 0 0 2px rgb(0 0 255 / 0.6) !important;
}

.ck.ai-writer__container {

  .ck-writer__action-save {
    background-color: #1D6EAA;
    color: #fff;
    border-radius: 8px;

    &:not(.ck-disabled):hover {
      background-color: #215c8b;
    }
  }

  .ai-writer__action-cancel {
    &:hover {
      background: linear-gradient(0deg, #696E7C, #696E7C), linear-gradient(0deg, #696E7C, #696E7C);
    }
  }

  .ck-writer__action-save, .ai-writer__action-cancel {
    border: none;

    svg path {
      fill: white;
    }
  }

  .ck-button__icon {
    height: 20px;
    width: 20px;
  }

  .ai-writer__form {
    input.ai-writer__prompt-input {
      font-size: 14px;
      background: linear-gradient(0deg, rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.05)),
                  linear-gradient(0deg, rgba(255, 255, 255, 0.03), rgba(255, 255, 255, 0.03));
      border: 1px solid #FFFFFF08;
      border-radius: 8px;
      color: #fff;
  
      &::placeholder {
        color: #FFFFFF80;
      }

      &[readonly] {
        color: #ffffff80
      }
    }
  
    .ai-writer__action-save {
      background: #1D6EAA;
      color: white;
      border-radius: 8px;
    }
  
    .ai-writer__action-cancel svg path {
      fill: white;
    }
  }

  .ai-writer__scrollable-container {
    background: linear-gradient(0deg, rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.05)),
    linear-gradient(0deg, rgba(255, 255, 255, 0.03), rgba(255, 255, 255, 0.03));
    border-radius: 8px;

    .ai-writer__scrollable-inner-container {
      padding: 6px;
    }

    .ai-writer__scrollable-container__text {
      color: white;
      font-family: "Inter";
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      text-align: left;

      /* width */
      ::-webkit-scrollbar {
        width: 4px;
      }

      /* Track */
      ::-webkit-scrollbar-track {
        box-shadow: inset 0 0 5px #FFFFFF4D; 
        border-radius: 10px;
      }
      
      /* Handle */
      ::-webkit-scrollbar-thumb {
        background: white; 
        border-radius: 10px;
      }

      /* Handle on hover */
      ::-webkit-scrollbar-thumb:hover {
        background: #a6a6a6; 
      }
    }
  }

  .ai-writer__actions-container {

    .ck-dropdown {
      margin-right: 12px;

      // Dropdown menu
      ul.ck-list{
        padding: 4px;
  
        button.ck-button.action-selected, button.ck-button:not(.action-selected):hover {
          background: rgba(255, 255, 255, 0.08);
  
          border-radius: 4px !important;
          padding: 6px, 8px;
          color: #BDBFC7;
  
          svg path {
            fill: white;
          }
        }
      }
    }

    .ck-dropdown__button.ai-writer__actions-change-length,
    .ck-dropdown__button.ai-writer__actions-change-tone,
    .ai-writer__actions-insert {
      &.ck-button {
        min-height: 32px;
        height: 32px;
        padding: 4px 8px;
        border-radius: 8px;
        border: 1px solid #696E7C;
        color: white;
        font-size: 14px;
        font-weight: 500;
        line-height: 24px;
        text-align: center;
      }

      &:not(.ck-disabled, .ck-on):hover {
        border: 1px solid #696E7C;
        background: linear-gradient(0deg, #696E7C, #696E7C), linear-gradient(0deg, #696E7C, #696E7C);
      }

      &.ck-on {
        background: linear-gradient(0deg, #696E7C, #696E7C), linear-gradient(0deg, #696E7C, #696E7C);
      }

      .ck-dropdown__arrow {
        display: unset;
      }
    }

    .ai-writer__actions-insert.ck-button {
      .ck-button__icon {
        margin-right: 12px;
        margin-left: 0;
      }
    }

    .ai-writer__actions-container--loading {
      .loader-dots {
        --dot-color: white;
      }
      color: white;

      font-size: 12px;
      font-weight: 400;
      line-height: 20px;
    }
  }
}

/* Content hub editor — hide scrollbars and reserve gutter so width never shifts on hover */
.content-page-editor {
  overflow: hidden !important;

  [data-content-hub-editor-scroll],
  [data-content-hub-settings-scroll],
  [data-content-hub-page-settings-scroll] {
    ${noScrollBar};
    scrollbar-gutter: stable;
  }
}
`;

export default GlobalStyles;
